<button
  type="button"
  [ngClass]="classes()"
  [matTooltip]="helpText()"
  class="flex justify-center items-center"
  [attr.aria-label]="helpAriaLabel()"
>
  <mat-icon aria-hidden="true">help</mat-icon>
</button>
